"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowLabel = exports.uuid = void 0;
const uuid = () => Math.random().toString(36).slice(-20);
exports.uuid = uuid;
const shouldShowLabel = (label) => Boolean(label);
exports.shouldShowLabel = shouldShowLabel;
//# sourceMappingURL=util.js.map